// extracted by mini-css-extract-plugin
export default {"titleText":"VerificationPendingCard_titleText__73iyp","descText":"VerificationPendingCard_descText__qBQR3"};